import React from 'react';
import './HeaderText.css';
import {FormattedMessage} from "react-intl";

export default () => (
    <div className="vitamin-care-header-text">
        <FormattedMessage id="vitamin.care.header" />
    </div>
);

